import useAuthStore from "../../store/authStore";

const ForbiddenAccessModal = () => {
    const { forbiddenAccess, hideForbiddenAccess } = useAuthStore();

  if (!forbiddenAccess) return null;
    return(
        <>
        <div className="modal fade in" style={{ display: "block" }}>
        <div className="modal-dialog" style={{ width: "500px" }}>
          <div className="modal-content">

            {/* HEADER */}
            <div
              className="modal-header"
              style={{ padding: "0px 0px" }}
            >
              <button
                type="button"
                className="close"
                onClick={hideForbiddenAccess}
              >
                &times;
              </button>
              <h4
                className="modal-title"
                style={{ margin: 0 }}
              >
                403 Forbidden Access!
              </h4>
            </div>

            {/* BODY */}
            <div className="modal-body">
              <p>
                You don't have permission to view this Page. Please return to login page.
              </p>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                onClick={hideForbiddenAccess}
              >
                Login Again
              </button>

            </div>

          </div>
        </div>
      </div></>
    );
}

export default ForbiddenAccessModal;